export const categories = [
  {
    slug: 'rain-sound',
    name: '雨声助眠',
    icon: 'ri-drizzle-line',
    description: '细雨、暴雨、屋檐雨滴等各类雨声 ASMR，模拟最自然的入眠环境，给您安稳的睡眠体验。',
    image: 'https://readdy.ai/api/search-image?query=gentle%20rain%20falling%20on%20window%20at%20night%2C%20warm%20cozy%20bedroom%20ambiance%2C%20soft%20warm%20amber%20lighting%2C%20peaceful%20sleep%20atmosphere%2C%20raindrops%20on%20glass%20with%20bokeh%20effect%2C%20minimalist%20aesthetic%2C%20cream%20and%20beige%20tones%2C%20dreamy%20soft%20focus%2C%20high%20quality%20cinematic%20photography&width=800&height=600&seq=cat-rain-01&orientation=landscape',
    articleCount: 12,
  },
  {
    slug: 'whisper',
    name: '耳语助眠',
    icon: 'ri-user-voice-line',
    description: '轻声耳语、温柔低语，由专业 ASMR 主播带来的耳语触发音，缓解焦虑放松心情。',
    image: 'https://readdy.ai/api/search-image?query=soft%20gentle%20whispering%20woman%20in%20warm%20lighting%2C%20cozy%20bedroom%20scene%20with%20soft%20pillows%2C%20dreamy%20ambient%20atmosphere%2C%20warm%20cream%20and%20beige%20tones%2C%20minimalist%20interior%2C%20peaceful%20and%20calm%20mood%2C%20soft%20focus%20photography%2C%20high%20quality%20cinematic%20shot&width=800&height=600&seq=cat-whisper-01&orientation=landscape',
    articleCount: 15,
  },
  {
    slug: 'tapping',
    name: '敲击音助眠',
    icon: 'ri-knife-line',
    description: '指甲敲击、木质敲击、塑料敲击等多种材质触发音，通过规律节奏带来放松体验。',
    image: 'https://readdy.ai/api/search-image?query=gentle%20fingertips%20tapping%20on%20wooden%20surface%2C%20warm%20cozy%20interior%20lighting%2C%20soft%20textures%20of%20wood%20and%20fabric%2C%20peaceful%20atmosphere%2C%20cream%20and%20warm%20brown%20tones%2C%20minimalist%20aesthetic%2C%20dreamy%20soft%20focus%2C%20cinematic%20photography%20quality&width=800&height=600&seq=cat-tapping-01&orientation=landscape',
    articleCount: 10,
  },
  {
    slug: 'white-noise',
    name: '白噪音助眠',
    icon: 'ri-sound-module-line',
    description: '风扇声、空调声、海浪声等持续白噪音，屏蔽环境杂音，打造纯净睡眠空间。',
    image: 'https://readdy.ai/api/search-image?query=soft%20ocean%20waves%20gently%20rolling%20on%20shore%20at%20dusk%2C%20warm%20golden%20hour%20light%2C%20peaceful%20coastal%20scene%2C%20cream%20and%20warm%20beige%20sand%20tones%2C%20dreamy%20atmosphere%2C%20minimalist%20composition%2C%20soft%20focus%20cinematic%20photography%2C%20tranquil%20mood&width=800&height=600&seq=cat-whitenoise-01&orientation=landscape',
    articleCount: 8,
  },
  {
    slug: 'roleplay',
    name: '角色扮演助眠',
    icon: 'ri-emotion-line',
    description: '模拟理发店、SPA、医疗检查等场景的角色扮演 ASMR，沉浸式体验帮助身心放松。',
    image: 'https://readdy.ai/api/search-image?query=cozy%20spa%20treatment%20room%20with%20soft%20candles%20and%20warm%20lighting%2C%20gentle%20relaxing%20atmosphere%2C%20cream%20colored%20towels%20and%20natural%20elements%2C%20peaceful%20ambiance%2C%20warm%20beige%20and%20soft%20green%20tones%2C%20minimalist%20luxury%20aesthetic%2C%20dreamy%20soft%20focus%2C%20cinematic%20quality&width=800&height=600&seq=cat-roleplay-01&orientation=landscape',
    articleCount: 9,
  },
  {
    slug: 'nature-sound',
    name: '自然音助眠',
    icon: 'ri-leaf-line',
    description: '鸟鸣、溪流、风吹树叶等大自然原声，让您在都市中也能感受森林般的宁静。',
    image: 'https://readdy.ai/api/search-image?query=peaceful%20forest%20with%20soft%20sunlight%20filtering%20through%20leaves%2C%20gentle%20stream%20flowing%2C%20warm%20natural%20tones%20of%20green%20and%20cream%2C%20dreamy%20atmosphere%2C%20minimalist%20nature%20composition%2C%20soft%20focus%20cinematic%20photography%2C%20tranquil%20and%20serene%20mood&width=800&height=600&seq=cat-nature-01&orientation=landscape',
    articleCount: 11,
  },
];

export const getCategoryBySlug = (slug: string) => {
  return categories.find((c) => c.slug === slug);
};